import type { Voucher } from '@src/domains/vouchers/types/voucher';
import { isVoucherPending } from '@src/domains/vouchers/core/isVoucherPending';

export const VoucherState = {
  Pending: 'pending',
  Revoked: 'revoked',
  Consumed: 'consumed',
  Open: 'open',
} as const;

export type VoucherState = (typeof VoucherState)[keyof typeof VoucherState];

export function getVoucherState(voucher: Voucher): VoucherState {
  if (isVoucherPending(voucher)) return VoucherState.Pending;
  if (voucher.revokedAt) return VoucherState.Revoked;
  if (voucher.consumedAt || voucher.exceptionallyConsumedAt) return VoucherState.Consumed;

  return VoucherState.Open;
}
